<template>
  <div>
    <!-- Hidden button to trigger modal -->
    <button class="d-none" data-toggle="modal" data-target="#AddPool" ref="openModalPool" @click="dataReset"></button>

    <!-- Add Pool Modal -->
    <div class="modal fade edit-pool-modal" tabindex="-1" role="dialog" id="AddPool">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Add New Pool</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModalPool"
              @click="closeModal()">
              <img src="../../../assets/Svg/close.svg" />
            </button>

          </div>

          <div class="modal-body">
            <div class="form-group">
              <input class="form-control" v-model.trim="poolName" spellcheck="false" autocomplete="off" type="text"
                required :class="{
                  'is-invalid': $v.poolName.$error,
                  'is-valid': !$v.poolName.$invalid,
                }" />
              <span class="placeholder">Pool Name</span>
              <span v-if="!$v.poolName.required" class="invalid-tooltip">
                Pool Name is required
              </span>
            </div>
          </div>

          <div class="event-btns-wrapper justify-content-end">
            <button type="button" class="btn btn-primary" :disabled="isLoading" @click="submitPool">
              <div v-if="isLoading" class="lds-dual-ring"></div>
              <div v-else>
                <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />
                Save
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AddPool",
  data() {
    return {
      poolName: "",
      tournamentId: "",
      tournamentguid: "",
      isLoading: false,
      sourceModal: null,
      tournamentData: [],
    };
  },
  validations: {
    poolName: {
      required
    },
  },
  methods: {

    dataReset() {
      this.poolName = "";
      this.$v.$reset();
    },
    async submitPool() {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      this.isLoading = true;
      try {
        const formData = new FormData();
        formData.append('pool_name', this.poolName);
        if (this.tournamentId) formData.append('tournament_id', this.tournamentId); // For add

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/addOrEditPool`,
          formData
        );

        const { statusCode, data, message } = response.data;

        if (statusCode === 200) {
          this.$root.$emit("refreshPool", { data, tournament_id: this.tournamentId, tournamentguid: this.tournamentguid });
          this.closeModal();
        } else {
          console.error("Error:", message);
        }
      } catch (err) {
        console.error("Failed to add/edit pool:", err);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.dataReset();
      var elem = this.$refs.closeModalPool;
      elem.click();
      if (this.sourceModal === 'editTeam') {
        setTimeout(() => {
          this.$root.$emit("openTournamentTeamsModal", this.tournamentData);
        }, 500);
      } else {
        setTimeout(() => {
          this.$emit("open-main-modal-again");
        }, 500);
      }
    },
  },
  mounted() {
    this.$root.$on("openAddPoolModal", ({ tournament_id, tournament_guid, source }) => {
      this.dataReset();
      this.tournamentId = tournament_id; // set tournament_id in data
      this.tournamentguid = tournament_guid;
      this.sourceModal = source;
      const elem = this.$refs.openModalPool;
      if (elem) {
        this.$nextTick(() => {
          elem.click();
        });
      }
    });
    this.$root.$on("openAddPoolModal2", ({ tournament_id, tournament_guid, source, tournamentData }) => {
      this.dataReset();
      this.tournamentId = tournament_id; // set tournament_id in data
      this.tournamentguid = tournament_guid;
      this.sourceModal = source;
      this.tournamentData = tournamentData;
      const elem = this.$refs.openModalPool;
      if (elem) {
        this.$nextTick(() => {
          elem.click();
        });
      }
    });
  },
};
</script>
<style>
/* Prevent affecting EditPool modal */
.edit-pool-modal .modal-content {
  height: auto !important;
  border-radius: 0.5rem !important;
  flex-direction: column !important;
}
</style>